export const resetAlbums = resp => ({
  type: "RESET_ALBUMS"
});

export const fetchAlbum = resp => ({
  type: "FETCH_ALBUM",
  payload: resp
});

export const fetchAlbums = resp => ({
  type: "FETCH_ALBUMS",
  payload: resp
});

export const saveAlbum = resp => ({
  type: "SAVE_ALBUM",
  payload: resp
});

export const setAlbumEditor = albumEditor => ({
  type: "SET_ALBUM_EDITOR",
  albumEditor
});

export const resetAlbumEditor = () => ({
  type: "RESET_ALBUM_EDITOR"
});

export const openAlbumEditor = () => ({
  type: "OPEN_ALBUM_EDITOR"
});

export const closeAlbumEditor = () => ({
  type: "CLOSE_ALBUM_EDITOR"
});

export const fetchInfiniteAlbums = resp => ({
  type: "FETCH_INFINITE_ALBUMS",
  payload: resp
});
export const removeMediaFromAlbumMedias = id => ({
  type: "REMOVE_MEDIA_FROM_ALBUM_MEDIAS",
  id
});
export const setAlbums = albums => ({
  type: "SET_ALBUMS",
  albums
});

export const setAlbum = album => ({
  type: "SET_ALBUM",
  album
});

export const deleteAlbum = resp => ({
  type: "DELETE_ALBUM",
  payload: resp
});

export const setOpenDeleteAlbum = visible => ({
  type: "SET_OPEN_DELETE_ALBUM",
  payload: visible
});

export const setEditorAlbum = album => ({
  type: "SET_EDITOR_ALBUM",
  payload: album
});

export const deleteEditorMedia = media => ({
  type: "DELETE_EDITOR_MEDIA",
  payload: media
});



// WEBPACK FOOTER //
// ./src/actions/actions/album.js